import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Icon,
  Input,
  Label
} from 'semantic-ui-react'

const CardEmployeeSummaryWorkHourUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="small --override-disabled --grey"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2">
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-6">
              <label
                id="CardEmployeeSummaryWorkHourUX-label-7">
                {props.languageUX === "en" ? "Division" : "แผนก"}
              </label>
              <Dropdown
                id="CardEmployeeSummaryWorkHourUX-Dropdown-8"
                loading={props.isLoadingDivision ?? false}
                name="division"
                onChange={props.onChangeDivision}
                options={props.divisionOptions}
                search={true}
                selection={true}
                value={props.filter?.division ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-9">
              <label
                id="CardEmployeeSummaryWorkHourUX-label-10">
                {props.languageUX === "en" ? "Select month" : "เลือกเดือน"}
              </label>
              <Dropdown
                id="CardEmployeeSummaryWorkHourUX-Dropdown-11"
                name="workShiftId"
                onChange={props.onChangeFilter}
                options={props.monthYearOptions}
                search={true}
                selection={true}
                value={props.filter?.workShiftId?? ""}>
              </Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-20"
            inline={true}
            style={{marginBottom: "1.5rem", display: props.readOnly?"none":""}}>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-21"
              inline={true}
              style={{minWidth: "13.5rem"}}
              width={2}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-23"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Apply OT cut off date" : "ใช้วันตัดโอที"}
              </label>
              <Input
                fluid={true}
                id="CardEmployeeSummaryWorkHourUX-Input-24"
                readOnly={true}
                value={props.otCutoffDate??""}>
              </Input>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-22">
              <div
                id="CardEmployeeSummaryWorkHourUX-div-25">
                {props.buttonApply}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-26"
              inline={true}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-30">
                {props.languageUX === "en" ? "Work Shift approved" : "อนุมัติกะการทำงาน"}
              </label>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-27"
              inline={true}>
              <Label
                id="CardEmployeeSummaryWorkHourUX-Label-34">
                <label
                  id="CardEmployeeSummaryWorkHourUX-label-35"
                  style={{color: "#009b14"}}>
                  {props.totalEmployeeApproved??"-"}
                </label>
                <label
                  id="CardEmployeeSummaryWorkHourUX-label-36">
                  /
                </label>
                <label
                  id="CardEmployeeSummaryWorkHourUX-label-37">
                  {props.totalEmployee??"-"}
                </label>
              </Label>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-28"
              inline={true}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-31">
                {props.languageUX === "en" ? "employees" : "พนักงาน"}
              </label>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-29"
              inline={true}
              style={{display: "flex", alignItems: "baseline"}}>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-38"
                style={{margin:0}}>
                {props.historyIcon}
              </div>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-33"
                style={{fontWeight:"normal", fontStyle: "italic"}}>
                {`Last updated: ${props.lastUpdated?.approved||"-"}`}
              </label>
            </FormField>
          </FormGroup>
        </Form>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15">
          {props.table}
        </div>
        <div
          className="ui form"
          id="CardEmployeeSummaryWorkHourUX-div-39"
          style={{marginTop: "1rem"}}>

          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-41"
            inline={true}
            style={{marginLeft: "11.25vw"}}>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-42"
              inline={true}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-50">
                {props.languageUX === "en" ? "Summary work hour send to Payroll" : "สรุปชั่วโมงการทำงานส่งไปที่บัญชีเงินเดือน"}
              </label>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-43"
              inline={true}>
              <Label
                id="CardEmployeeSummaryWorkHourUX-Label-49">
                <label
                  id="CardEmployeeSummaryWorkHourUX-label-51"
                  style={{color: "#009b14"}}>
                  {props.totalSentPayrolls??"-"}
                </label>
                <label
                  id="CardEmployeeSummaryWorkHourUX-label-52">
                  /
                </label>
                <label
                  id="CardEmployeeSummaryWorkHourUX-label-53">
                  {props.totalEmployee??"-"}
                </label>
              </Label>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-44"
              inline={true}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-48">
                {props.languageUX === "en" ? "employees" : "พนักงาน"}
              </label>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-45"
              inline={true}
              style={{display: "flex", alignItems: "baseline"}}>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-46"
                style={{margin:0}}>
                {props.historyIcon}
              </div>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-47"
                style={{fontWeight:"normal", fontStyle: "italic"}}>
                {`Last updated: ${props.lastUpdated?.sent||"-"}`}
              </label>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-16"
          style={{marginTop: "1rem", display: "flex", justifyContent: "flex-end"}}>

          <Button
            color="yellow"
            icon={true}
            id="CardEmployeeSummaryWorkHourUX-Button-17"
            onClick={props.onPrintReport}
            size="small">
            <Icon
              id="CardEmployeeSummaryWorkHourUX-Icon-18"
              name="print">
            </Icon>
            <label
              id="CardEmployeeSummaryWorkHourUX-label-19"
              style={{marginLeft: "6px"}}>
              {props.languageUX === "en" ? "Print summary of Work/OT hour" : "พิมพ์สรุปชั่วโมงการทำงาน/OT"}
            </label>
          </Button>
        </div>
      </div>
    )
}


export default CardEmployeeSummaryWorkHourUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Aug 29 2025 11:23:14 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "small --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-6"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "Division"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-7"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Dropdown",
      "parent": 6,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Dropdown-8"
        },
        "loading": {
          "type": "code",
          "value": "props.isLoadingDivision ?? false"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDivision"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division ?? \"\""
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-9"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกเดือน",
          "valueEN": "Select month"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-10"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Dropdown",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Dropdown-11"
        },
        "name": {
          "type": "value",
          "value": "workShiftId"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.monthYearOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.workShiftId?? \"\""
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\", display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 16,
      "props": {
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Button-17"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintReport"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Icon",
      "parent": 17,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Icon-18"
        },
        "name": {
          "type": "value",
          "value": "print"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์สรุปชั่วโมงการทำงาน/OT",
          "valueEN": "Print summary of Work/OT hour"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-20"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1.5rem\", display: props.readOnly?\"none\":\"\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-21"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"13.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-22"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "ใช้วันตัดโอที",
          "valueEN": "Apply OT cut off date"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-23"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Input",
      "parent": 21,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Input-24"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.otCutoffDate??\"\""
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 22,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonApply"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-25"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 26,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-26"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-27"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-28"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "FormField",
      "parent": 20,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-29"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"baseline\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "label",
      "parent": 26,
      "props": {
        "children": {
          "type": "value",
          "value": "อนุมัติกะการทำงาน",
          "valueEN": "Work Shift approved"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "label",
      "parent": 28,
      "props": {
        "children": {
          "type": "value",
          "value": "พนักงาน",
          "valueEN": "employees"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-31"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "`Last updated: ${props.lastUpdated?.approved||\"-\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"normal\", fontStyle: \"italic\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Label",
      "parent": 27,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Label-34"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalEmployeeApproved??\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-35"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#009b14\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": "/"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-36"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "label",
      "parent": 34,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalEmployee??\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-37"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "div",
      "parent": 29,
      "props": {
        "children": {
          "type": "code",
          "value": "props.historyIcon"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-38"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormGroup",
      "parent": 39,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"11.25vw\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 41,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"baseline\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "props.historyIcon"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{margin:0}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "code",
          "value": "`Last updated: ${props.lastUpdated?.sent||\"-\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-47"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"normal\", fontStyle: \"italic\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 44,
      "props": {
        "children": {
          "type": "value",
          "value": "พนักงาน",
          "valueEN": "employees"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Label",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Label-49"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": "สรุปชั่วโมงการทำงานส่งไปที่บัญชีเงินเดือน",
          "valueEN": "Summary work hour send to Payroll"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalSentPayrolls??\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-51"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#009b14\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "/"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "code",
          "value": "props.totalEmployee??\"-\""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-53"
        }
      },
      "seq": 53,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardEmployeeSummaryWorkHourUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
